<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-3 p-5">
            <tt-select ttRememberId="w_stockbatchsearch.businessco_no" ttLabel="businessco" [(ttModel)]="setting.businessco_no" [ttData]="selectListCompanies" (ttModelChange)="onChanged($event, 'businessco_no')" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
            <tt-select ttRememberId="w_stockbatchsearch.stockplace_id" ttLabel="stockplace" [(ttModel)]="setting.stockplace_id" [ttData]="selectListStockPlaces" (ttModelChange)="onChanged($event, 'stockplace_id')" ttDataId="stockplace_id" ttDataName="stockplace_name"></tt-select>

            <form class="form-horizontal sp-0" name="formStockBatchSearch" novalidate (ngSubmit)="searchItems()" method="get" role="form">
                <tt-input ttRememberId="w_stockbatchsearch.searchtext" ttLabel="searchtext" ttFocus="false" [(ttModel)]="setting.searchtext" (ttModelChange)="onChanged($event, 'searchtext')" ttShowClearButton [ttButtons]="searchTextButtons"></tt-input>
            </form>
        </tt-card>

        <tt-card class="col-xs-12 col-md-3 p-5" *ngIf="setting.show_setting === '1'">
            <tt-button-settings></tt-button-settings>
        </tt-card>
    </div>

    <tt-grid *ngIf="!!grid" class="p-5 flex-1" [(ttOptions)]="grid"></tt-grid>
</tt-page>
